<template>
  <div class="AgentCommission">
    <div class="datatable-form__header atr-header-wrap mb-4">
      <div class="invoiceList-search_item">
        <el-input v-model="searchagentcommissionagentname" type="text" placeholder="Agent Name"></el-input>
      </div>
      <div class="invoiceList-search_item">
        <el-input v-model="searchagentcommissionstudentname" type="text" placeholder="Student Name"></el-input>
      </div>

      <div class="datatable-form__submit text-center">
        <button class="btn btn-success searchbtn" id="btnReceiptSearch" v-on:click="Search('AgentTracker')">Search</button>
      </div>
    </div>
    <div class="">
      <div class="datatable-form__submit text-right"></div>
      <div class="pb-5">
        <!--alexis-->
        <el-tabs v-model="receiptTab" type="card">
          <el-tab-pane label="Student Receipt List" name="first">
            <div class="datatable_group">
              <div>
                <el-button-group class="pull-right mb-3">
                  <!--<el-button size="small" type="primary" icon="el-icon-download" :disabled="AuditDisabled" v-on:click="downloadAsZip()">Download</el-button>-->
                  <el-button size="small" type="primary" v-on:click="showBModal('NewAgentCommission')" style="display: none">Add New</el-button>
                  <!--<el-button size="small" type="primary" icon="el-icon-download" :disabled="AuditDisabled" v-on:click="showTestBModal()">Send Batch Email (test)</el-button>-->
                </el-button-group>
              </div>
              <data-tables
                :data="ReceiptListInt"
                :action-col="ReceiptListAction"
                @selection-change="changeSelection"
                width="55"
                stripe
                tooltip-effect="light"
                border
                ref="ReceiptListTable"
              >
                <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
                <el-table-column
                  v-for="item in ReceiptList"
                  :prop="item.prop"
                  :label="item.label"
                  :key="item.prop"
                  :hidden="!item.show"
                  sortable="custom"
                  v-if="item.show"
                >
                </el-table-column>
              </data-tables>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!--alexis>-->
    <b-modal id="showNewAgentCommissionModal" hide-footer title="New Agent Commission" size="sm" ref="showNewAgentCommissionModal">
      <div class="datatable-form__header atr-header-wrap mb-4">
        <div class="invoiceList-search_item">
          Agent Name:
          <h5>{{ txtAgentComm_agentname }}</h5>
        </div>
        <div class="invoiceList-search_item">
          Student No:
          <h5>{{ txtAgentComm_studentno }}</h5>
        </div>

        <div class="invoiceList-search_item">
          Student Name:
          <h5>{{ txtAgentComm_StudentName }}</h5>
        </div>
        <div class="invoiceList-search_item" style="display: none">
          Max Commission:
          <h5>{{ txtAgentComm_receiptamount }}</h5>
        </div>
      </div>

      <div class="datatable-form__header atr-header-wrap mb-4">
        <div class="invoiceList-search_item">
          Academic Year:
          <select v-model="ddlAcademicYearEdit" class="form-control pro-edt-select form-control-primary" @change="bindSemesterTerm()">
            <option v-for="item in ddlAcademicYearEditList" v-bind:value="item.PK_Semester_ID">
              {{ item.SMT_Code }}
            </option>
          </select>
        </div>

        <div class="invoiceList-search_item">
          Semester/Term:
          <select v-model="ddlSemesterTermEdit" class="form-control pro-edt-select form-control-primary" @change="bindReceipt()">
            <option v-for="item in ddlSemesterTermEditList" v-bind:value="item.PK_SEMD_ID">
              {{ item.SEMD_DetailName }}
            </option>
          </select>
        </div>

        <div class="invoiceList-search_item">
          Receipt No:
          <el-select style="max-width: 150px" v-model="AgtNewCommReceipt" clearable placeholder="Receipt No">
            <el-option v-for="item in AgtNewCommReceipt" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </div>
      </div>

      <div class="datatable-form__header atr-header-wrap mb-4">
        <div class="invoiceList-search_item">
          Receipt Amount: <el-input v-model="txtAgentComm_receiptamount" type="text" placeholder="Receipt Amount"></el-input>
        </div>

        <div class="date">
          Paid to Agent Date:
          <el-date-picker v-model="inputPaidAgentDate" format="dd/MM/yyyy" value-format="dd/MM/yyyy" type="date" placeholder="Pick a date"></el-date-picker>
        </div>

        <div class="invoiceList-search_item">
          Agent Invoice No: <el-input v-model="txtAgentComm_InvoiceRefNo" type="text" placeholder="Agent Invoice No"></el-input>
        </div>
      </div>

      <div class="datatable-form__header atr-header-wrap mb-4">
        <div class="invoiceList-search_item">
          Commission Paid To Agent: <el-input v-model="txtAgentComm_Commission" type="text" placeholder="Commission Paid To Agent"></el-input>
        </div>

        <div class="invoiceList-search_item">Remarks: <el-input v-model="txtAgentComm_Remarks" type="text" placeholder="Remarks"></el-input></div>

        <div class="invoiceList-search_item">
          Status:
          <el-select style="max-width: 150px" v-model="AgentCommStatus" clearable placeholder="Status">
            <el-option v-for="item in AgentCommOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </div>
      </div>

      <div class="invoice-modal_submitBox">
        <strong></strong>
        <el-button size="small" type="primary" v-on:click="btnSaveAgentCommission('Yes')">Save</el-button>
        <el-button size="small" type="danger" v-on:click="btnSaveAgentCommission('No')">Cancel</el-button>
      </div>
    </b-modal>

    <!--alexis>-->
    <b-modal id="showEditAgentCommissionModal" hide-footer title="Edit Agent Commission" size="sm" ref="showEditAgentCommissionModal">
      <div class="datatable-form__header atr-header-wrap mb-4">
        <div class="invoiceList-search_item">
          Agent Name:
          <h5>{{ txtAgentComm_agentname }}</h5>
        </div>
        <div class="invoiceList-search_item">
          Student No:
          <h5>{{ txtAgentComm_studentno }}</h5>
        </div>

        <div class="invoiceList-search_item">
          Student Name:
          <h5>{{ txtAgentComm_StudentName }}</h5>
        </div>
        <div class="invoiceList-search_item" style="display: none">
          Max Commission:
          <h5>{{ txtAgentComm_receiptamount }}</h5>
        </div>
      </div>

      <div class="datatable-form__header atr-header-wrap mb-4">
        <div class="invoiceList-search_item">
          Academic Year:
          <h5>{{ txtAgentComm_academicyear }}</h5>
        </div>

        <div class="invoiceList-search_item">
          Receipt No:
          <h5>{{ txtAgentComm_receiptno }}</h5>
        </div>

        <div class="invoiceList-search_item">
          Receipt Date:
          <h5>{{ txtAgentComm_receiptdate }}</h5>
        </div>

        <div class="invoiceList-search_item" style="display: none">
          Semester/Term:
          <h5>{{ txtAgentComm_Term }}</h5>
        </div>
      </div>

      <div class="datatable-form__header atr-header-wrap mb-4">
        <div class="invoiceList-search_item">
          Total Commission:
          <h5>{{ txtAgentComm_TotalCommission }}</h5>
        </div>

        <div class="invoiceList-search_item">
          Total Paid Commission:
          <h5>{{ txtAgentComm_TotalPaidCommission }}</h5>
        </div>

        <div class="invoiceList-search_item">
          Total Outstanding Commission:
          <h5>{{ txtAgentComm_TotalOutstandingCommission }}</h5>
        </div>
      </div>

      <div class="datatable-form__header atr-header-wrap mb-4">
        <div class="invoiceList-search_item">
          * Receipt Amount: <el-input v-model="txtAgentComm_receiptamount" type="text" placeholder="Receipt Amount" @change="updateCommission()"></el-input>
        </div>

        <div class="invoiceList-search_item">
          * Commission Paid To Agent: <el-input v-model="txtAgentComm_Commission" type="text" placeholder="Commission Paid To Agent"></el-input>
        </div>

        <div class="date">
          * Paid to Agent Date:
          <el-date-picker v-model="inputPaidAgentDate" format="dd/MM/yyyy" value-format="dd/MM/yyyy" type="date" placeholder="Pick a date"
            >txtAgenComm_PaidAgentDate</el-date-picker
          >
        </div>
      </div>

      <div class="datatable-form__header atr-header-wrap mb-4">
        <div class="invoiceList-search_item">
          Agent Invoice No: <el-input v-model="txtAgentComm_InvoiceRefNo" type="text" placeholder="Agent Invoice No"></el-input>
        </div>

        <div class="invoiceList-search_item">Remarks: <el-input v-model="txtAgentComm_Remarks" type="text" placeholder="Remarks"></el-input></div>

        <div class="invoiceList-search_item">
          * Status:
          <el-select v-model="AgentCommStatus" clearable placeholder="Status">
            <el-option v-for="item in AgentCommOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </div>
      </div>

      <div class="invoice-modal_submitBox">
        <strong></strong>
        <el-button size="small" type="primary" v-on:click="btnSaveAgentCommissionEdit('Yes')">Save</el-button>
        <el-button size="small" type="danger" v-on:click="btnSaveAgentCommissionEdit('No')">Cancel</el-button>
      </div>
    </b-modal>

    <b-modal id="showBatchEmailConfirmationModal" hide-footer title="Send Email Confirmation" size="sm" ref="showBatchEmailConfirmationModal">
      <data-tables
        :data="SelectedReceiptListInts"
        v-if="SelectedReceiptListInts && SelectedReceiptListInts.length > 0"
        width="55"
        stripe
        tooltip-effect="light"
        border
        ref="selectedListTable"
      >
        <el-table-column v-for="item in selectedReceiptList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
      </data-tables>

      <div class="invoice-modal_submitBox">
        <strong>Proceed to send email??</strong>
        <el-button size="small" type="primary" icon="el-icon-s-promotion" v-on:click="btnSendEmail()">Yes</el-button>
        <el-button size="small" type="danger" icon="el-icon-s-promotion" v-on:click="btnSendEmail('No')">No</el-button>
      </div>
    </b-modal>
    <b-modal
      id="showBatchEmailConfirmationModalWithBreakdown"
      hide-footer
      title="Send Email Confirmation With Breakdown"
      size="sm"
      ref="showBatchEmailConfirmationModalWithBreakdown"
    >
      <data-tables
        :data="SelectedReceiptListInts"
        v-if="SelectedReceiptListInts && SelectedReceiptListInts.length > 0"
        width="55"
        stripe
        tooltip-effect="light"
        border
        ref="selectedListTable"
      >
        <el-table-column v-for="item in selectedReceiptList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
      </data-tables>

      <div class="invoice-modal_submitBox">
        <strong>Proceed to send email??</strong>
        <el-button size="small" type="primary" icon="el-icon-s-promotion" v-on:click="btnSendEmailWithBreakdown()">Yes</el-button>
        <el-button size="small" type="danger" icon="el-icon-s-promotion" v-on:click="btnSendEmailWithBreakdown('No')">No</el-button>
      </div>
    </b-modal>
    <!--        //testing only: start-->
    <b-modal id="showTestingBModal" hide-footer title="Send Email Confirmation(TEST ONLY!)" size="sm" ref="showTestingBModal">
      <data-tables
        :data="testingSelectedReceiptListInt"
        v-if="testingSelectedReceiptListInt && testingSelectedReceiptListInt.length > 0"
        width="55"
        stripe
        tooltip-effect="light"
        border
        ref="selectedListTable"
      >
        <el-table-column v-for="item in testingSelectedReceiptList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
        <el-table-column label="Email(TEST)" min-width="100px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.newTestEmail" type="text" placeholder="Email(Key in test email)"></el-input>
          </template>
        </el-table-column>
      </data-tables>

      <div class="invoice-modal_submitBox">
        <strong>Proceed to send email??</strong>
        <el-button size="small" type="primary" icon="el-icon-s-promotion" v-on:click="btnTestingSendEmail()">Yes</el-button>
        <el-button size="small" type="danger" icon="el-icon-s-promotion" v-on:click="btnTestingSendEmail('No')">No</el-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import DataSource from '../../data/datasource'
import moment from 'moment'
import Cookies from 'js-cookie'

export default {
  name: 'AgentTracker-Receipt',
  data() {
    return {
      startupText: '',
      inputFromDate: [],
      inputFromDueDate: [],
      studName: '',
      agentName: '',

      searchagentcommissionagentname: '',
      searchagentcommissionstudentname: '',

      recName: '',
      recStatus: 'Active',
      recOptions: [
        {
          value: 'Active',
          label: 'Active',
        },
        {
          value: 'Void',
          label: 'Void',
        },
      ],
      schSelected: '',
      userSchools: [],
      receiptTab: 'first',

      currentSchoolID: '',

      txtAgentComm_editid: '',
      txtAgentComm_agentid: '',
      txtAgentComm_agentname: '',
      txtAgentComm_academicyear: '',
      txtAgentComm_Ssemesterid: '',
      txtAgentComm_SMT_Code: '',
      txtAgentComm_receiptno: '',
      txtAgentComm_receiptdate: '',
      txtAgentComm_receiptamount: '',
      txtAgentComm_Commission: '',
      txtAgentComm_Remarks: '',
      txtAgentComm_Status: '',
      txtAgentComm_InvoiceRefNo: '',
      txtAgentComm_studentno: '',
      txtAgentComm_StudentName: '',
      txtAgentComm_studentid: '',

      txtAgentComm_TotalCommission: '',
      txtAgentComm_TotalPaidCommission: '',
      txtAgentComm_TotalOutstandingCommission: '',

      txtAgentComm_SemID: '',
      txtAgentComm_Term: '',
      txtAgenComm_PaidAgentDate: '',

      AgentCommStatus: 'Pending',

      AgtNewCommReceipt: '',

      ddlAcademicYearEditList: [],
      ddlAcademicYearEdit: '',

      ddlSemesterTermEditList: [],
      ddlSemesterTermEdit: '',

      inputPaidAgentDate: '',

      AgentCommOptions: [
        {
          value: 'Pending',
          label: 'Pending',
        },
        {
          value: 'Paid',
          label: 'Paid',
        },
      ],

      AgtNewCommReceiptOptions: [
        {
          value: 'Pending',
          label: 'Pending',
        },
        {
          value: 'Paid',
          label: 'Paid',
        },
      ],

      //receiptList:start
      ReceiptListAction: {
        label: 'Action',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-el-date-editor',
            },

            handler: row => {
              this.txtAgentComm_editid = row.editid
              this.txtAgentComm_agentid = row.agentid
              this.txtAgentComm_agentname = row.agentname
              this.txtAgentComm_academicyear = row.academicyear
              this.txtAgentComm_Ssemesterid = row.semesterid
              this.txtAgentComm_SMT_Code = row.SMT_Code
              this.txtAgentComm_receiptno = row.receiptno
              this.txtAgentComm_receiptdate = row.receiptdate
              this.txtAgentComm_receiptamount = row.receiptamount

              if (row.oldCommission == 0.0) {
                this.txtAgentComm_Commission = row.Commission
              } else {
                this.txtAgentComm_Commission = row.oldCommission
              }

              this.txtAgentComm_Remarks = row.Remarks
              this.txtAgentComm_Status = row.Status
              this.txtAgentComm_InvoiceRefNo = row.InvoiceRefNo
              this.txtAgentComm_studentno = row.studentno
              this.txtAgentComm_StudentName = row.StudentName

              this.txtAgentComm_TotalCommission = row.totalcommission
              this.txtAgentComm_TotalPaidCommission = row.totalpaidcommission
              this.txtAgentComm_TotalOutstandingCommission = row.totalunpaidcommission

              this.txtAgentComm_studentid = row.StudentId
              this.txtAgentComm_SemID = row.PK_SEMD_ID
              this.txtAgentComm_Term = row.Term
              this.txtAgenComm_PaidAgentDate = row.PaidToAgentDate
              this.inputPaidAgentDate = row.PaidToAgentDate
              this.AgentCommStatus = row.Status

              this.ddlAcademicYearEditList = []
              this.ddlSemesterTermEditList = []

              this.showBModal('EditAgentCommission')
            },
            label: 'Edit',
          },
        ],
      },
      ReceiptListInt: [],
      ReceiptList: [
        {
          prop: 'editid',
          label: 'editid',
          show: false,
        },
        {
          prop: 'agentid',
          label: 'agentid',
          show: false,
        },
        {
          prop: 'agentname',
          label: 'agentname',
          show: true,
        },
        {
          prop: 'academicyear',
          label: 'academicyear',
          show: true,
        },
        {
          prop: 'semesterid',
          label: 'Semesterid',
          show: false,
        },
        {
          prop: 'Term',
          label: 'Semester/Term',
          show: false,
        },
        {
          prop: 'SMT_Code',
          label: 'SMT_Code',
          show: false,
        },
        {
          prop: 'receiptno',
          label: 'receiptno',
          show: true,
        },
        {
          prop: 'receiptdate',
          label: 'receiptdate',
          show: true,
        },
        {
          prop: 'receiptamount',
          label: 'receiptamount',
          show: true,
        },
        {
          prop: 'oldCommission',
          label: 'Commission',
          show: true,
        },
        {
          prop: 'Commission',
          label: 'Commission',
          show: false,
        },
        {
          prop: 'Remarks',
          label: 'Remarks',
          show: true,
        },
        {
          prop: 'Status',
          label: 'Status',
          show: true,
        },
        {
          prop: 'InvoiceRefNo',
          label: 'InvoiceRefNo',
          show: false,
        },
        {
          prop: 'studentno',
          label: 'studentno',
          show: true,
        },
        {
          prop: 'StudentName',
          label: 'StudentName',
          show: true,
        },
        {
          prop: 'StudentId',
          label: 'StudentId',
          show: false,
        },
        {
          prop: 'totalcommission',
          label: 'Total Commission',
          show: true,
        },
        {
          prop: 'totalpaidcommission',
          label: 'Paid Commission',
          show: true,
        },
        {
          prop: 'totalunpaidcommission',
          label: 'Pending Commission',
          show: true,
        },
        {
          prop: 'PK_SEMD_ID',
          label: 'PK_SEMD_ID',
          show: false,
        },
      ],

      ReceiptListWithoutPayeeEmailInt: [],
      ReceiptListWithoutPayeeEmail: [
        {
          prop: 'studentName',
          label: 'Student Name',
        },
        {
          prop: 'RH_Receipt_Status',
          label: 'Receipt Status',
        },
        {
          prop: 'RH_Receipt_Name',
          label: 'Receipt Name',
        },
        {
          prop: 'email',
          label: 'Email',
        },
        {
          prop: 'sponsor_type',
          label: 'Payee',
        },
      ],
      ReceiptListWithoutPayeeEmailAction: {
        label: 'More info',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-info',
            },

            handler: row => {
              this.studentCourseID = row.PK_Student_Course_ID
              this.studentID = row.FK_Student_ID
              this.courseStatus = row.SCRS_Status
              if (this.studentCourseID) {
                this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus)
              } else {
                this.$notify.error({
                  title: 'Message',
                  message: 'Error.',
                })
              }
            },
            label: 'More info',
          },
        ],
      },
      //receiptList:end

      tempResp: [],
      spdSelection: [],
      zipType: '',
      testingSelectedReceiptListInt: [],
      testingSelectedReceiptList: [
        {
          prop: 'studentName',
          label: 'Student Name',
        },
        {
          prop: 'RH_Receipt_Status',
          label: 'Receipt Status',
        },
        {
          prop: 'RH_Receipt_Name',
          label: 'Receipt Name',
        },
        {
          prop: 'email',
          label: 'Email',
        },
        {
          prop: 'sponsor_type',
          label: 'Payee',
        },
        {
          prop: 'fatherEmail',
          label: 'Father Email',
        },
        {
          prop: 'motherEmail',
          label: 'Mother Email',
        },
      ],
      SelectedReceiptListInts: [],
      selectedReceiptList: [
        {
          prop: 'studentName',
          label: 'Student Name',
        },
        {
          prop: 'RH_Receipt_Status',
          label: 'Receipt Status',
        },
        {
          prop: 'RH_Receipt_Name',
          label: 'Receipt Name',
        },
        {
          prop: 'email',
          label: 'Email',
        },
        {
          prop: 'sponsor_type',
          label: 'Payee',
        },
        {
          prop: 'fatherEmail',
          label: 'Father Email',
        },
        {
          prop: 'motherEmail',
          label: 'Mother Email',
        },
      ],
      AuditDisabled: false,
    }
  },
  mounted() {
    this.initEvent()
    //todo: for external auditor only

    let conType = Cookies.get('userTypeSession')
    if (conType === 'Auditor') {
      this.AuditDisabled = true
    }
    //todo: for external auditor only
  },
  props: ['propReceiptListInt', 'propCurrentSchoolID', 'propReceiptListWithoutPayeeEmailInt', 'propZipType', 'propSpdSelection'],
  methods: {
    async changeSelection(val) {
      this.spdSelection = val
    },
    initEvent() {
      let tmpagentcommissionagentname = Cookies.get('agentcommissionagentname')
      let tmpagentcommissionstudentname = Cookies.get('agentcommissionstudentname')

      if (tmpagentcommissionagentname === 'undefined') {
        tmpagentcommissionagentname = ''
      }
      if (tmpagentcommissionstudentname === 'undefined') {
        tmpagentcommissionstudentname = ''
      }

      this.searchagentcommissionagentname = tmpagentcommissionagentname
      this.searchagentcommissionstudentname = tmpagentcommissionstudentname

      this.ReceiptListInt = this.propReceiptListInt
      this.currentSchoolID = this.propCurrentSchoolID
      this.ReceiptListWithoutPayeeEmailInt = this.propReceiptListWithoutPayeeEmailInt
      this.zipType = this.propZipType
      this.spdSelection = this.propSpdSelection
      this.getUserSch()

      this.Search('AgentCommission')

      //  console.log(this.zipType)
    },

    async bindSemesterTerm() {
      try {
        alert(this.txtAgentComm_Ssemesterid)
        const response = await DataSource.shared.getddlSemesterTermList(this.txtAgentComm_Ssemesterid)

        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.SemesterTermListResponse = response.Table
            this.SemesterTermListResponse.forEach(m => {
              this.ddlSemesterTermEditList.push(m)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    //ALEXIS
    async BindDDLAcadYear() {
      try {
        const response = await DataSource.shared.getddlAcadYearList(this.txtAgentComm_studentid)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.AcadeemiYearListResponse = response.Table
            this.AcadeemiYearListResponse.forEach(m => {
              this.ddlAcademicYearEditList.push(m)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    //alexis
    async btnSaveAgentCommissionEdit(value) {
      if (value === 'No') {
        this.txtAgentComm_editid = ''
        this.txtAgentComm_agentid = ''
        this.txtAgentComm_agentname = ''
        this.txtAgentComm_academicyear = ''
        this.txtAgentComm_Ssemesterid = ''
        this.txtAgentComm_SMT_Code = ''
        this.txtAgentComm_receiptno = ''
        this.txtAgentComm_receiptdate = ''
        this.txtAgentComm_receiptamount = ''
        this.txtAgentComm_Commission = ''
        this.txtAgentComm_Remarks = ''
        this.txtAgentComm_Status = ''
        this.txtAgentComm_InvoiceRefNo = ''
        this.txtAgentComm_studentno = ''
        this.txtAgentComm_StudentName = ''

        this.txtAgentComm_TotalCommission = ''
        this.txtAgentComm_TotalPaidCommission = ''
        this.txtAgentComm_TotalOutstandingCommission = ''

        this.txtAgentComm_studentid = ''
        this.txtAgentComm_SemID = ''
        this.txtAgentComm_Term = ''
        this.txtAgenComm_PaidAgentDate = ''
        this.inputPaidAgentDate = ''
        this.AgentCommStatus = ''

        this.$refs.showEditAgentCommissionModal.hide()
      } else {
        //some validations before save
        if (!Number.isInteger(parseInt(this.txtAgentComm_Commission))) {
          this.$notify.error({
            title: 'Message',
            message: 'Cannot Save - invalid Commission',
          })
          return
        }

        if (!Number.isInteger(parseInt(this.txtAgentComm_receiptamount))) {
          this.$notify.error({
            title: 'Message',
            message: 'Cannot Save - invalid Receipt Amount',
          })
          return
        }

        if (this.inputPaidAgentDate == '') {
          this.$notify.error({
            title: 'Message',
            message: 'Cannot Save - missing Paid Agent Date',
          })
          return
        }

        this.$emit(
          'btnSaveAgentCommission',
          value,
          this.txtAgentComm_editid,
          this.txtAgentComm_receiptamount,
          this.txtAgentComm_Commission,
          this.inputPaidAgentDate,
          this.txtAgentComm_InvoiceRefNo,
          this.txtAgentComm_Remarks,
          this.AgentCommStatus,
          this.txtAgentComm_agentid,
          this.txtAgentComm_studentid,
          this.txtAgentComm_receiptno,
          this.txtAgentComm_SemID,
          'SaveAgentCommission',
        )

        this.txtAgentComm_editid = ''
        this.txtAgentComm_agentid = ''
        this.txtAgentComm_agentname = ''
        this.txtAgentComm_academicyear = ''
        this.txtAgentComm_Ssemesterid = ''
        this.txtAgentComm_SMT_Code = ''
        this.txtAgentComm_receiptno = ''
        this.txtAgentComm_receiptdate = ''
        this.txtAgentComm_receiptamount = ''
        this.txtAgentComm_Commission = ''
        this.txtAgentComm_Remarks = ''
        this.txtAgentComm_Status = ''
        this.txtAgentComm_InvoiceRefNo = ''
        this.txtAgentComm_studentno = ''
        this.txtAgentComm_StudentName = ''

        this.txtAgentComm_TotalCommission = ''
        this.txtAgentComm_TotalPaidCommission = ''
        this.txtAgentComm_TotalUnpaidCommission = ''

        this.txtAgentComm_studentid = ''
        this.txtAgentComm_SemID = ''
        this.txtAgentComm_Term = ''
        this.txtAgenComm_PaidAgentDate = ''
        this.inputPaidAgentDate = ''
        this.AgentCommStatus = ''

        this.$refs.showEditAgentCommissionModal.hide()

        setTimeout(() => (this.isHidden = false), 7000)

        this.Search('AgentCommission')
      }
    },

    async updateCommission() {
      //alert('compute')
      this.txtAgentComm_Commission = parseFloat(this.txtAgentComm_receiptamount).toFixed(2) * 0.15
    },

    async getUserSch() {
      try {
        const resp = await DataSource.shared.getUserSch()
        this.userSchools = resp.Table
      } catch (e) {
        this.results = e
      }
    },
    async Search(type) {
      try {
        this.clearTablesList()
        this.clearBModalList()
        //todo: to check empty input, force to input at least 1 datetime

        this.$vs.loading()
        const resp = await DataSource.shared.getAgentCommissionList(this.searchagentcommissionagentname, this.searchagentcommissionstudentname, type)

        if (resp) {
          if (resp.code === '88') {
            window.location.replace('/')
          } else if (resp.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Search Agent Commission: Error',
            })
          } else if (resp.code === '2') {
            this.$notify.error({
              title: 'No Record',
              message: 'No Agent Commission Found',
            })
          } else {
            this.ReceiptListInt = []
            this.tempResp = resp.Table
            // this.ReceiptListInt = this.tempResp;
            this.tempResp.forEach(m => {
              this.ReceiptListInt.push(m)

              Cookies.set('agentcommissionagentname', this.searchagentcommissionagentname, { expires: 3 / 24 })
              Cookies.set('agentcommissionstudentname', this.searchagentcommissionstudentname, { expires: 3 / 24 })
            })
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async clearTablesList() {
      this.ReceiptListInt = []
      this.ReceiptListWithoutPayeeEmailInt = []
    },
    async clearBModalList() {
      //   console.log("clearBModalList");
      this.spdSelection = []
      this.SelectedReceiptListInts = []
    },
    async downloadAsZip() {
      try {
        let spdList = []
        let selectedObjList = []
        spdList = this.spdSelection
        if (this.spdSelection && this.spdSelection.length < 1) {
          alert('Please select at least 1 item!')
        } else {
          this.$vs.loading()
          spdList.forEach(m => {
            let List = {
              RH_Receipt_No: m.RH_Receipt_No,
            }
            selectedObjList.push(List)
          })

          const resp = await DataSource.shared.getZipFiles(JSON.stringify(selectedObjList), this.zipType)
          if (resp.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Cannot download files!',
            })
          } else {
            var byteChar = atob(resp.code)
            var byteNo = new Array(byteChar.length)
            for (var i = 0; i < byteChar.length; i++) {
              byteNo[i] = byteChar.charCodeAt(i)
            }
            var byteArray = new Uint8Array(byteNo)
            var file = new Blob([byteArray], { type: 'application/zip;base64' })
            var fileUrl = URL.createObjectURL(file)
            window.location.href = fileUrl
          }
          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async downloadReceiptWithoutEmailAsZip() {
      try {
        let selectedObjList = []
        this.ReceiptListWithoutPayeeEmailInt.forEach(m => {
          let List = {
            IH_Invoice_No: m.IH_Invoice_No,
          }
          selectedObjList.push(List)
        })
        const resp = await DataSource.shared.getZipFiles(JSON.stringify(selectedObjList), this.zipType)
        if (resp.code === '99') {
          this.$notify.error({
            title: 'Error',
            message: 'Cannot download files!',
          })
        } else {
          let byteChar = atob(resp.code)
          let byteNo = new Array(byteChar.length)
          for (let i = 0; i < byteChar.length; i++) {
            byteNo[i] = byteChar.charCodeAt(i)
          }
          let byteArray = new Uint8Array(byteNo)
          let file = new Blob([byteArray], { type: 'application/zip;base64' })
          let fileUrl = URL.createObjectURL(file)
          window.location.href = fileUrl
        }
      } catch (e) {
        this.results = e
      }
    },
    async showBModal(mode) {
      if (mode == 'EditAgentCommission') {
        //await this.BindDDLAcadYear(this.txtAgentComm_studentid);
        //await this.bindSemesterTerm();

        this.$refs.showEditAgentCommissionModal.show()

        //this.ddlAcademicYearEdit = this.txtAgentComm_Ssemesterid;
        //this.ddlSemesterTermEdit = this.txtAgentComm_SemID;
      }

      if (mode == 'NewAgentCommission') {
        await this.BindDDLAcadYear(this.txtAgentComm_studentid)
        await this.bindSemesterTerm()

        this.$refs.showNewAgentCommissionModal.show()

        this.ddlAcademicYearEdit = this.txtAgentComm_Ssemesterid
        this.ddlSemesterTermEdit = this.txtAgentComm_SemID
      }
    },
    async showBModalWithBreakdown() {
      try {
        if (this.spdSelection && this.spdSelection.length < 1) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 item!',
          })
        } else {
          this.$refs.showBatchEmailConfirmationModalWithBreakdown.show()
          await this.getSelectedList()
        }
      } catch (e) {
        this.results = e
      }
    },
    async getSelectedList() {
      this.SelectedReceiptListInts = this.spdSelection
    },
    async getTestingSelectedList() {
      this.testingSelectedReceiptListInt = this.spdSelection
    },
    //Testing items only: start
    async showTestBModal() {
      try {
        //todo: check if no checkbox selected
        if (this.spdSelection && this.spdSelection.length < 1) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 item!',
          })
        } else {
          this.$refs.showTestingBModal.show()
          await this.getTestingSelectedList()
        }
      } catch (e) {
        this.results = e
      }
    },
    hideModal() {
      this.$refs.showBatchEmailConfirmationModal.hide()
      this.$refs.showTestingBModal.hide()
      this.$refs.showBatchEmailConfirmationModalWithBreakdown.hide()
    },
    async btnSendEmail(value) {
      this.$emit('btnSendEmail', value, this.spdSelection, 'receipt')
    },
    async btnSendEmailWithBreakdown(value) {
      this.$emit('btnSendEmailWithBreakdown', value, this.spdSelection, 'receipt')
    },
    async btnTestingSendEmail(value) {
      this.$emit('btnTestingSendEmail', value, this.spdSelection, 'receipt')
    },
    async btnTestingSendEmailWithBreakdown(value) {
      this.$emit('btnTestingSendEmailWithBreakdown', value, this.spdSelection, 'receipt')
    },
  },
}
</script>
<style scoped></style>
<style>
#invoice-list .AgentTracker-receipt .action-list button {
  padding: 5px !important;
  margin: 0;
}

#invoice-list .AgentTracker-receipt .action-list {
  margin: 0 -10px !important;
}
</style>
